module.exports = __webpack_public_path__ + "static/premium-web-befac670537d63010f0ff8318c18cfa5.webp";